import { BuyPhoneNumber } from './BuyPhoneNumber'

export const PhoneNumberPage = () => {
   return (
      <div className="flex-1">
         <BuyPhoneNumber />
      </div>
   )
}
